/**
 * A no operation function (does nothing)
 */
export function noop() { }
